import { Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import React, { useEffect, useState } from 'react'
import ExpandLessIcon from '@material-ui/icons/ExpandLess'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import effects from 'app/effects/effects'
import clsx from 'clsx'
import CloseIcon from '@material-ui/icons/Close'
import {
  SOCIAL_PROVIDER_KEY_FACEBOOK,
  SOCIAL_PROVIDER_KEY_INSTAGRAM,
} from '../../../configs/socialMediaIntegrationConfig'
import './styles/facebook-pages-modal.css'

export default function SocialMediaPagesModal({
  placeId,
  onClose,
  isInstagramModal,
}) {
  const [pages, setPages] = useState([])
  const [isOpen, setIsOpen] = useState(false)
  const [pagesBlockIsOpened, setPagesBlockIsOpened] = useState(true)
  const [clickedButtonIndex, setClickedButtonIndex] = useState(-1)
  const currentSocialProvider = isInstagramModal ? 'instagram' : 'facebook'
  const currentSocialProviderKey = isInstagramModal
    ? SOCIAL_PROVIDER_KEY_INSTAGRAM
    : SOCIAL_PROVIDER_KEY_FACEBOOK

  useEffect(() => {
    effects.apis
      .getSocialProviderPages({ placeId })
      .then((socialMediaPages) => {
        let pages = socialMediaPages[currentSocialProvider]
        setPages(pages)
        setIsOpen(true)
      })
  }, [currentSocialProvider, currentSocialProviderKey, placeId])

  const handleConnectionStatusChange = async (pageId, status) => {
    try {
      setClickedButtonIndex(pageId)
      await effects.apis.updateSocialPageConnectionStatus({
        placeId,
        socialProviderKey: currentSocialProviderKey,
        pageId,
        status,
      })
      let pageIndex = await pages.findIndex((element) => element.id === pageId)
      let pagesArr = [...pages]
      let page = await { ...pagesArr[pageIndex] }
      page.status = status
      pagesArr[pageIndex] = await page
      setClickedButtonIndex(-1)
      setPages(pagesArr)
    } catch (e) {
      throw new Error(e.message)
    }
  }

  const handleClose = () => {
    setIsOpen(false)
    onClose()
  }

  return (
    <Dialog
      open={isOpen}
      className="facebook-pages-modal"
      onBackdropClick={() => handleClose()}
    >
      <DialogTitle>
        <CloseIcon
          className="facebook-pages-modal-close-icon"
          onClick={() => handleClose()}
        />
        <FormattedMessage
          id={`socialMediaIntegrations.provider.${currentSocialProvider}.modal.title`}
        />
        <div className="facebook-pages-modal-descriptions-block">
          <p className="facebook-pages-modal-description">
            <FormattedMessage
              id={`socialMediaIntegrations.provider.${currentSocialProvider}.modal.description`}
            />
          </p>
        </div>
      </DialogTitle>
      <DialogContent>
        {pages.length === 0 ? (
          <div className="w-full mb-10">
            <FormattedMessage
              id="socialMediaIntegrations.provider.not.pages"
              values={{
                provider: currentSocialProvider,
              }}
            />
          </div>
        ) : (
          <div
            className={clsx('facebook-pages-block', {
              opened: pagesBlockIsOpened,
            })}
          >
            <div
              className="facebook-pages-block-title-block"
              onClick={() => setPagesBlockIsOpened(!pagesBlockIsOpened)}
            >
              <FormattedMessage
                id={`socialMediaIntegrations.provider.${currentSocialProvider}.modal.pages.block.title`}
                className="facebook-pages-block-title"
              />
              {pagesBlockIsOpened ? (
                <ExpandLessIcon className="arrow-icon" />
              ) : (
                <ExpandMoreIcon className="arrow-icon" />
              )}
            </div>
            <div className="facebook-pages-list-block">
              {pages.map((page, index) => (
                <div className="facebook-pages-list-item" key={index}>
                  <img
                    src={page.imageUrl}
                    alt={page.name}
                    className="facebook-page-image"
                  />
                  <h6 className="facebook-page-name">{page.name}</h6>
                  {page.status === 1 ? (
                    <button
                      type="button"
                      onClick={() => handleConnectionStatusChange(page.id, 0)}
                      disabled={
                        clickedButtonIndex > 0
                          ? clickedButtonIndex !== page.id
                            ? true
                            : false
                          : ''
                      }
                      className={clsx('facebook-page-button', {
                        'facebook-page-button-disconnect': page.status,
                      })}
                    >
                      <FormattedMessage id="socialMediaIntegrations.provider.facebook.modal.pages.button.disconnect" />
                    </button>
                  ) : (
                    <button
                      type="button"
                      onClick={() => handleConnectionStatusChange(page.id, 1)}
                      disabled={
                        clickedButtonIndex > 0
                          ? clickedButtonIndex !== page.id
                            ? true
                            : false
                          : ''
                      }
                      className={clsx('facebook-page-button', {
                        'facebook-page-button-connect': !page.status,
                      })}
                    >
                      <FormattedMessage id="socialMediaIntegrations.provider.facebook.modal.pages.button.connect" />
                    </button>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
